import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	panelSplitter: {
		id: 'preview-panel-api.resize.label',
		defaultMessage: 'Resize panel',
		description: 'label text for a button that will allow resizing of the preview panel',
	},
});
